<template>
  <PagesPublicationsComponent
    :pageData="data"
    :childData="childData"
    :paginateChildData="paginateChildData"
  />

  <NuxtPage />
</template>

<script setup>
// 1
defineI18nRoute({
  paths: {
    en: '/publications',
    nl: '/publicaties'
  }
})

// 2
const queryPath = queryPublicationsPage(baseStrapiGetSlugQueryObjectFromRoute())
const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryPath } }
  )
})

if (!data?.value?.data?.id || error?.value) {
  throw createError({ statusCode: 404 })
}

pageSetHead(data)

// 3
const { data: childData, error: childError } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryPublicationEntryThumbnails(baseRouteGetPublicationStateQuery()) } }
  )
})

const paginateChildData = async () => {
  const { data: nextData, error: nextError } = await useAsyncData(() => {
    return $fetch('/api/strapi-rest',
      { query: { path: queryPublicationEntryThumbnails({ ...baseRouteGetPublicationStateQuery(), page: childData?.value?.meta?.pagination?.page + 1 }) } }
    )
  })

  if (nextData?.value) {
    childData.value.data = childData.value.data.concat(nextData.value.data)
    childData.value.meta = nextData.value.meta
  }
}
</script>
